export const Bio = {
  name: "Constanza Rassi",
  description:
    "I'm a passionate professional with a strong background in software development.",
  cv: "https://drive.google.com/file/d/1yW2nMhyk6VuhTcY18Zv5EDS0YVUIAXAN/view?usp=sharing",
  image:
    "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/me.JPEG?alt=media&token=62e16dd7-37fc-49b3-a17c-efc2e16261ce",
  github: "https://github.com/ConstanzaRassi",
  resume:
    "https://drive.google.com/file/d/1yW2nMhyk6VuhTcY18Zv5EDS0YVUIAXAN/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/constanzarassi/",
  insta: "https://www.instagram.com/cotirassi/",
};

export const skills = [
  {
    title: "Backend",
    skills: [
      {
        name: "C#",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/c%23-logo.svg?alt=media&token=c9393041-83ab-4bc0-ab26-0ef690675605",
      },
      {
        name: ".NET",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/dotnet-logo.png?alt=media&token=b32f1a64-4695-4d7f-b087-080f55452c72",
      },
      {
        name: "Microservices",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/microservices-logo.png?alt=media&token=c52c7e9a-6ac4-4063-91f4-08a2fe07c250",
      },
      {
        name: "Java",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/java-logo.png?alt=media&token=e5b27f98-9dcc-4323-a034-937449946825",
      },
      {
        name: "RabbitMQ",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/rabbitmq-logo.png?alt=media&token=4a3c4a77-99dc-4482-bb9e-1cd0328966b1",
      },
      {
        name: "Quartz",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/quartz_logo.png?alt=media&token=8a40ecb9-ac14-470b-bc78-fff64e555459",
      },
      {
        name: "GO",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/go-logo.png?alt=media&token=e97a2b9f-24ab-47e5-b630-3aaeb6ea1873",
      },
    ],
  },
  {
    title: "Database",
    skills: [
      {
        name: "SQL Server",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/sqlserver-logo.png?alt=media&token=8b3123b6-4ac2-4075-9549-f7f1ddc59cae",
      },
      {
        name: "MongoDB",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/mongodb-logo.png?alt=media&token=6aa9abea-3e85-45b6-ad52-7ef658f3e89b",
      },
      {
        name: "Firebase",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/firebase-logo.png?alt=media&token=58c038e9-552d-414a-93e7-163c0cf9282c",
      },

      {
        name: "PostgreSQL",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/postgresql-logo.png?alt=media&token=01f1ac25-b7e0-473f-b7f6-f6427f9b724c",
      },

      {
        name: "Redis",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/redis-logo.png?alt=media&token=d911a559-1c50-47b6-adbd-4e4abf37b723",
      },
      {
        name: "MySQL",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/mysql-logo.png?alt=media&token=4937a1b8-6b54-4696-abf3-51b770424c40",
      },
    ],
  },
  {
    title: "Frontend",
    skills: [
      {
        name: "React",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/react-logo.png?alt=media&token=a4f2a540-df6d-4a96-9ba6-72050ef7f683",
      },
      {
        name: "Javascript",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/javascript-logo.png?alt=media&token=265d74ae-9db2-41c2-bb4f-89983b2b61aa",
      },
      {
        name: "HTML",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/html-logo.png?alt=media&token=7bc63ddc-94bc-4c56-9b15-532a107f7b4e",
      },
      {
        name: "CSS",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/css-logo.png?alt=media&token=af6d614b-c926-4ae6-9b66-496e528cf19f",
      },
      {
        name: "Bootstrap",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/bootstrap-logo.png?alt=media&token=f4549183-fe72-4dda-97a2-9b0f7d158a83",
      },
      {
        name: "Angular",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/angular-logo.png?alt=media&token=ac498c49-d41e-45de-9903-64f39128bdeb",
      },
      {
        name: "TypeScript",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/typescript-logo.png?alt=media&token=ca521f2a-953e-4892-b204-ec5f4f2889d4",
      },
      // {
      //   name: "Vue",
      //   image:
      //     "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/vue-logo.png?alt=media&token=63ae32a6-4990-456a-8ea6-38fd53cbe166",
      // },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/git-logo.png?alt=media&token=391118ba-1896-40f3-87b1-b5e20080c48a",
      },
      {
        name: "Docker",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/docker-logo.png?alt=media&token=78f454b6-73d2-46fe-9cd2-e1e4e9c5ca07",
      },
      {
        name: "Azure",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/azure-logo.png?alt=media&token=0895c272-e7af-4aef-8b07-61a13c03a87f",
      },
      {
        name: "Kubernetes",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/kubernetes-logo.png?alt=media&token=06b5f161-3092-4a61-ad1e-7f0d3412b407",
      },
      {
        name: "AWS",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/aws-logo.png?alt=media&token=3751b87c-b599-4fbf-85e2-7c24d2960916",
      },
      // {
      //   name: "SignalR",
      //   image:
      //     "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/signalr-logo.svg?alt=media&token=20baa884-cf82-47d4-9d53-079c3a76b959",
      // },
      {
        name: "Postman",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/postman-logo.svg?alt=media&token=ec5437fc-4f67-4114-95b4-a4d772e96e84",
      },
      {
        name: "Studio3T",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/studio3t-logo.png?alt=media&token=0caef284-9623-4aa8-bb91-5f19b6f24d59",
      },
      {
        name: "Jira",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/jira-logo.png?alt=media&token=7a033d42-9bd9-4837-ad68-f45d11ad079c",
      },
      // {
      //   name: "Jenkins",
      //   image:
      //     "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/jenkins-logo.png?alt=media&token=a8f97bb8-e2bb-4d3e-83ad-ad12bde46e5c",
      // },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/meli-logo.jpg?alt=media&token=7e67c781-6eb6-4267-94c2-0d9d61387918",
    role: "Software Engineer",
    company: "Mercado Libre",
    desc: "My responsibilities include: \n· Developing and maintaining Java microservices on high-availability architectures using MySQL HA, HikariCP, and JDBC.\n· Implementing resilience patterns, including circuit breakers, graceful shutdown, and connection pooling tuning.\n· Instrumenting traces and metrics using the OpenTelemetry standard, with visualization and monitoring through Datadog, Grafana, and Kibana.\n· Reducing technical debt through refactoring and maintainability improvements.\n· Managing event/stream processing.\n· Addressing security vulnerabilities, including endpoint hardening and IDOR vulnerabilities.\n· Using the company's internal CI/CD platform for continuous microservices deployment.",
    date: "Feb 2026 - Present",
    skills: [
      "Java",
      "Go",
      "MySQL",
      "Microservices",
      "Stream messages",
      "OTEL",
      "Datadog",
      "Grafana",
    ],
  },
  {
    id: 1,
    img: "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/shifta-logo.png?alt=media&token=f79015c7-624e-44c6-bd91-57b566ea7c9b",
    role: "Software Engineer",
    company: "SHIFTA",
    date: "Apr 2024 - Jan 2026",
    desc: "My responsibilities have included: \n· Development and implementation of APIs with microservice architecture in .NET.\n· Design and creation of SQL databases.\n· Collaboration on DevOps tasks with Azure.\n· Job scheduling with Quartz.\n· Analysis of different business workflows to design application architecture and code structure.\n· Participate in front-end development tasks using React | NextJs.\n· Developing clean and well-covered unit tests with XUnit and Moq.",
    skills: [
      ".NET Core",
      "Microservices",
      "SQL",
      "Quartz",
      "React",
      "Azure",
      "NextJs",
      "XUnit",
      "OpenXML",
    ],
  },
  {
    id: 2,
    img: "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/jt-logo.jpg?alt=media&token=2b79f9f4-70b5-48c6-976a-25f0b3cbbc6b",
    role: "Software Developer",
    company: "Juan Toselli International Tours",
    date: "Feb 2022 - Mar 2024",
    desc: "My responsibilities have included:\n· Leading projects for the integration of supplier Web Services (SOAP/Rest) into the company's system.\n· Migration from a monolithic system to a microservices-based architecture in .NET.\n· Designing and creating SQL databases.\n· Crafting scripts for scheduled tasks using JavaScript and MongoDB. \n· Implementing payment platforms, e.g. Binance.\n· Deployment and monitoring with Limestone and DigitalOcean.\n· Collaborating on front-end projects using Angular.",
    skills: [
      ".NET Core",
      "Microservices",
      "MongoDB",
      "SQL",
      "Web Services",
      "Digital Ocean",
      "Nginx",
      "JavaScript",
      "Linux",
      "RabbitMQ",
      "Angular",
    ],
  },
  {
    id: 3,
    img: "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/globant-logo.png?alt=media&token=ada0a12d-955c-49af-a3ce-fbd99569a470",
    role: "QA Internship",
    company: "Globant",
    date: "Sep 2019 - Oct 2019",
    desc: "Completed a school-sponsored internship during my final year of high school, supporting the QA and Testing team by performing various simple tasks to assist with their daily operations.",
    skills: [],
  },
];

export const education = [
  {
    id: 0,
    img: "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/unc-logo.png?alt=media&token=7fb9684c-a77b-4d36-8f41-af7f88d87e25",
    school: "National University of Cordoba",
    date: "Jan 2024 - Oct 2024",
    desc: "The diploma addresses the comprehensive cloud software development including security, database, monitoring tools, IAC. It covers key concepts in the ICT industry, such as continuous integration and continuous delivery using Docker and Kubernetes.",
    degree: "Diploma in DevOps",
  },
  {
    id: 1,
    img: "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/utn-logo.png?alt=media&token=516e2b8b-6930-453e-9309-1c3769908d5a",
    school: "National Technological University",
    date: "Feb 2020 - Jul 2022",
    grade: "8.67 CGPA",
    desc: "Completed by acquiring knowledge in the fundamental pillars of SQL database management, object-oriented programming with C# and Java, basic principles of web programming (using Bootstrap) and understanding of company accounting and administrative systems.",
    degree: "Technical Degree in Programming",
  },
  {
    id: 3,
    img: "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/sanjose-logo.png?alt=media&token=7cb4c293-9292-493f-816d-c8203b0bc449",
    school: "San Jose School, Cordoba",
    date: "Mar 2008 - Dec 2019",
    grade: "88.2%",
    desc: "Completed with a specialization in humanities at a educational institution, including grades K-12",
    degree: "Elementary / High School",
  },
];

export const projects = [
  {
    id: 1,
    title: "Labor",
    date: "Apr 2024 - Jul 2025",
    description:
      "Labor was a multi-initiative project for AESA-YPF focused on automating monthly labor and accounting workflows. The system centralizes file ingestion and data validation, applies complex business rules, and orchestrates large-scale calculations to reduce time and errors.\nTo operate under high concurrency, it introduced background jobs that prevent blocking and ensure continuity.\n\nThe work also included independent test environments with real-world cases, along with configuration, deployment, and monitoring in Azure.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/aesa.png?alt=media&token=ff37f743-495a-4764-95e9-e4d4e9324226",
    tags: [
      ".NET",
      "Entity Framework",
      "SQL",
      "React",
      "NextJS",
      "Azure",
      "Quartz",
      "XUnit",
      "OpenXML",
      "JWT",
    ],
    category: "work",
    github: "",
    webapp: "",
    private: true,
  },
  {
    id: 2,
    title: "NDC Integrations",
    date: "Apr 2022 - Jan 2024",
    description:
      "I led the NDC integration projects bringing airlines’ New Distribution Capability NDC into the company's system, enabling agencies across the country to book and issue airline tickets more efficiently.\nCopa Airlines selected us as the first company in Argentina to implement this integration, and the project was successfully completed. We also delivered integrations with LATAM Airlines, American Airlines, Iberia, British Airways, Avianca, and Sabre.\n\nIn addition to the technical challenges, the work included certifications with provider teams, security validations, use case creation, and training for all users nationwide who would be using the tool.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/ndc-bg.png?alt=media&token=6933ce17-f0a5-480e-ad57-f9e98581e6aa",
    tags: [".NET", "MongoDB", "Angular", "SOAP", "JWT", "Limestone Networks"],
    category: "work",
    github: "",
    webapp: "",
    private: true,
  },
  {
    id: 3,
    title: "Binance-Integrated Payments",
    date: "Aug 2022 - Dec 2022",
    description:
      "Designed and built a cryptocurrency payment platform integrating Binance APIs, which allowed users to make transactions and payments with various cryptocurrencies. Implemented secure authentication, transaction tracking, real-time price updates, and error handling with retries.\n\nManaged the end-to-end integration and deployment (API key management, environment setup, monitoring/alerts, and audit logs) on a scalable architecture. Successfully implemented the platform, resulting in increased transaction volume and improved user experience.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/binance-bg.jpg?alt=media&token=0d68bd36-3297-412b-8810-dc92c6ab952b",
    tags: [
      ".NET",
      "MongoDB",
      "REST",
      "Binance API",
      "Web Socket",
      "Angular",
      "JavaScript",
      "JWT",
    ],
    category: "work",
    github: "",
    webapp: "",
    private: true,
  },
  {
    id: 4,
    title: "English Tutors Argentina",
    date: "Aug 2021 - Nov 2021",
    description:
      "English Tutors Arg is a customized project tailored for an English academy in Argentina. Beyond just providing class and fares information, the client wanted a platform with additional content like vocabulary, phrases, and expressions. They also requested an exercises section to appeal to potential users.\n\nTo address the teachers' need for assessing the proficiency levels of prospective students, an exam section was incorporated. This assessment, implemented through a Google Form, allows for a thorough evaluation.\n\nThe result is a website that serves not only as an informative resource but also as an engaging space where learning and evaluation coexist",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/englishtutors-bg.png?alt=media&token=3070546e-512d-40ee-abbf-2176c5b56b67",
    tags: ["Angular"],
    category: "work",
    github: "https://github.com/NataliaTodesco/english-tutors",
    webapp: "https://elegant-euler-9b518f.netlify.app/",
    private: false,
  },
  {
    id: 5,
    title: "Vitamove",
    date: "Jan 2022 - Jul 2022",
    description:
      "Vitamove is the project I developed to present my university thesis in 2022. It is a website for a chain of gyms, where you can log in as an administrator or as a student. Various graphics and tables were designed for the administrator interface to manage data and statistics.\n\nFor the student interface, it includes basic functionalities such as class registration and viewing administrative status. Additionally, students can make payments for a plan using the Mercado Pago platform.\n\n As a final feature, there is an interactive 3D model of the human body with different muscle groups. This allows users to select specific muscle groups they want to work on and create a routine tailored to those muscles.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/vitamove-bg.png?alt=media&token=9a08a841-abee-4167-ab8d-70bb155180d7",
    tags: [
      ".NET",
      "PostgreSQL",
      "Bootstrap",
      "Javascript",
      "Mercado Pago",
      "PHP",
      "JQuery",
      "SketchFab",
    ],
    category: "personal",
    github: "https://github.com/ConstanzaRassi/PracticaSupervisada",
    webapp: "https://youtu.be/-XgbRnMy8q0",
    private: false,
  },
];

export const certifications = [
  {
    id: 0,
    title: "Devops Diploma",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/devops-certificado.png?alt=media&token=da3aedaa-9830-4597-b59f-b006a9c46a83",
  },
  {
    id: 1,
    title: "High Concurrency",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/high-concurrency-certification.jpg?alt=media&token=390ad6f1-45db-4493-815b-0a048eeb0a20",
  },
  {
    id: 2,
    title: "AI for Work",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/ai-for-work-certification.jpg?alt=media&token=75244d3d-3ec3-4664-abbf-8de217a16cb5",
  },
  {
    id: 3,
    title: "Scrum Fundamentals",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/scrum-certification.jpg?alt=media&token=c69dc241-b373-4e98-bc09-74462b701c14",
  },
  {
    id: 4,
    title: "Git Basics",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-rassi.appspot.com/o/git-certification.jpg?alt=media&token=d090ee6d-e261-4912-a70e-c6db5d811b33",
  },
];
